<section class="cr-static cr-howto">
  <div class="cr-static__inner">
    <header class="cr-static__hero">
      <span class="cr-static__eyebrow">So funktioniert's</span>
      <h1 class="cr-static__title">
        Drei Schritte vom<br>Anliegen zum erledigten Auftrag.
      </h1>
      <p class="cr-static__lead">
        Anfragen ist kostenlos. Bezahlt wird erst nach erfolgreicher Erledigung —
        und das Geld bleibt bis dahin sicher im Treuhand-Hold.
      </p>
    </header>

    <ol class="cr-howto__steps" aria-label="Ablauf in drei Schritten">
      <li class="cr-howto__step">
        <div class="cr-howto__step-num"><span>01</span><small>/ 03</small></div>
        <div class="cr-howto__step-body">
          <h2 class="cr-howto__step-title">Anfrage stellen</h2>
          <p class="cr-howto__step-lead">
            Beschreibe dein Anliegen, lade Fotos hoch. Kostet nichts.
          </p>
          <ul class="cr-howto__step-list">
            <li>PLZ + Gewerk eingeben</li>
            <li>Foto hochladen, Wunschtermin angeben</li>
            <li>Anfrage absenden — keine Anmeldung nötig</li>
          </ul>
        </div>
      </li>

      <li class="cr-howto__step">
        <div class="cr-howto__step-num"><span>02</span><small>/ 03</small></div>
        <div class="cr-howto__step-body">
          <h2 class="cr-howto__step-title">Festpreise vergleichen</h2>
          <p class="cr-howto__step-lead">
            Verifizierte Handwerksbetriebe in deiner Nähe schicken dir
            verbindliche Angebote — werktags innerhalb 24&nbsp;Stunden.
          </p>
          <ul class="cr-howto__step-list">
            <li>Bis zu 5 Angebote pro Anfrage</li>
            <li>Festpreis statt Stundenrechnung</li>
            <li>Profil, Bewertungen und Termin sichtbar</li>
          </ul>
        </div>
      </li>

      <li class="cr-howto__step">
        <div class="cr-howto__step-num"><span>03</span><small>/ 03</small></div>
        <div class="cr-howto__step-body">
          <h2 class="cr-howto__step-title">Buchen &amp; entspannen</h2>
          <p class="cr-howto__step-lead">
            Du wählst dein Angebot. Wir halten die Zahlung treuhänderisch —
            bis der Job sauber erledigt ist.
          </p>
          <ul class="cr-howto__step-list">
            <li>Zahlung bei Buchung, Geld bleibt im Hold</li>
            <li>Handwerker startet Auftrag mit deinen Kontaktdaten</li>
            <li>Nach Abschluss: 24&nbsp;h Bestätigungsfrist, dann Auszahlung</li>
          </ul>
        </div>
      </li>
    </ol>

    <section class="cr-howto__faq">
      <h2 class="cr-static__h2">Häufige Fragen</h2>
      <ul class="cr-howto__faq-list">
        <li>
          <a routerLink="/hilfe/kunden" fragment="anfrage-kosten">
            Was kostet eine Anfrage?
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </a>
        </li>
        <li>
          <a routerLink="/hilfe/kunden" fragment="rechnung">
            Wer stellt mir die Rechnung?
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </a>
        </li>
        <li>
          <a routerLink="/hilfe/kunden" fragment="maengel">
            Was passiert bei Mängeln?
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </a>
        </li>
        <li>
          <a routerLink="/hilfe/kunden" fragment="stornieren">
            Kann ich eine Buchung stornieren?
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </a>
        </li>
      </ul>
      <a routerLink="/hilfe/kunden" class="cr-howto__faq-all">
        Alle Fragen ansehen →
      </a>
    </section>

    <section class="cr-static__cta">
      <h2 class="cr-static__cta-title">Bereit anzufragen?</h2>
      <p class="cr-static__cta-lead">
        In zwei Minuten beschrieben, Angebote werktags binnen 24 h.
      </p>
      <div class="cr-static__cta-row">
        <a routerLink="/anfrage/neu" class="cr-btn cr-btn--primary">Jetzt Anliegen schildern</a>
      </div>
    </section>
  </div>
</section>
